import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import React from 'react';
import './index.scss';
import { BhHeaderV2Lang } from 'eco-design/section-layout/ef-header-v2/BhHeaderV2Lang';
import gtm from 'eco-design-reliance/gtm';
import getLocal from 'eco-design-reliance/getLocal';
import { getCardAnimation, getTarget } from '../common';
import { getUrlGtm } from '@/utils/gtmUtils';

interface Props {
    prefixCls: string;
    activeItemB: any;
    active?: boolean;
    isH5?: boolean;
    title: string;
}

const TypeContent: React.FC<Props> = ({ prefixCls, activeItemB, active, isH5, title }) => {
    const { locale = '' } = getLocal();
    const t = BhHeaderV2Lang[locale] || BhHeaderV2Lang['en'];
    const lItemsSubs = activeItemB.subs || []; // 二级内容
    let rItemsSubs: any[] = [];
    try {
        const extJson = activeItemB?.extJson;
        if (extJson && extJson.trim() !== '') {
            rItemsSubs = JSON.parse(extJson);
        } else {
            rItemsSubs = [];
        }
    } catch (e) {
        rItemsSubs = [];
    }

    return (
        <>
            {activeItemB.subtitle && (
                <div className={`${prefixCls}-card-type-a__title ${isH5 ? 'isH5' : ''} ${active ? 'active' : ''}`}>{activeItemB.subtitle}</div>
            )}
            <div className={`${prefixCls}-card-type-a__content  ${isH5 ? 'isH5' : ''} ${active ? 'active' : ''}`}>
                <div className={`${prefixCls}-card-type-a__content-left`}>
                    {lItemsSubs.map((i: any, idx: number) => {
                        return (
                            <div
                                className={`${prefixCls}-card-type-a__content-left-item`}
                                style={{
                                    animation: getCardAnimation(idx),
                                }}
                                key={i.id || idx}
                            >
                                <EcoLink
                                    className={`GtmModuleData-btn-href l-i-img-${idx}`}
                                    href={i.learnMoreUrl || i.buyUrl}
                                    target={getTarget(i.learnMoreUrl || i.buyUrl)}
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'top_third_navigation',
                                        position: 'Header Navigation',
                                        navigation_name: `${title}_${activeItemB.name}_${i.heading}`,
                                        list_name: activeItemB.name,

                                        __btn_id1: `l-i-img-${idx}`,
                                        __btn_id2: i.learnMoreUrl || i.buyUrl,
                                        __btn_type: 'href',
                                    }}
                                >
                                    <EcoImg className={`${prefixCls}-card-type-a__content-left-item-img`} pc={i.pictureUrl} />
                                </EcoLink>
                                <div className={`${prefixCls}-card-type-a__content-left-item-label`}>{t.label[i.label] || i.label}</div>
                                <div className={`${prefixCls}-card-type-a__content-left-item-title`}>{i.heading}</div>
                                <div className={`${prefixCls}-card-type-a__content-left-item-desc`}>{i.subtitle}</div>
                                {(i.buyUrl || i.learnMoreUrl) && (
                                    <div className={`${prefixCls}-card-type-a__content-left-item-btns`}>
                                        {i.learnMoreUrl && (
                                            <EcoLink
                                                className={`${prefixCls}-card-type-a__content-left-item-more l-i-more-${idx} GtmModuleData-btn-href`}
                                                href={i.learnMoreUrl}
                                                target={getTarget(i.learnMoreUrl)}
                                                dataLayer={{
                                                    navigation_name: `${title}_${activeItemB.name}_${i.heading}`,
                                                    position: 'Header Navigation',
                                                    ...getUrlGtm(i.learnMoreUrl, locale, {
                                                        product_name: i.heading,
                                                        list_name: activeItemB.name,
                                                        button_name: t.more,
                                                    }),
                                                    __btn_id1: `l-i-more-${idx}`,
                                                    __btn_id2: i.learnMoreUrl,
                                                    __btn_type: 'href',
                                                }}
                                            >
                                                {t.more}
                                            </EcoLink>
                                        )}
                                        {i.buyUrl && (
                                            <EcoLink
                                                className={`${prefixCls}-card-type-a__content-left-item-buy l-i-buy-${idx} GtmModuleData-btn-href`}
                                                href={i.buyUrl}
                                                target={getTarget(i.buyUrl)}
                                                dataLayer={{
                                                    navigation_name: `${title}_${activeItemB.name}_${i.heading}`,
                                                    position: 'Header Navigation',
                                                    ...getUrlGtm(i.buyUrl, locale, {
                                                        product_name: i.heading,
                                                        list_name: activeItemB.name,
                                                        button_name: t.buy,
                                                    }),
                                                    __btn_id1: `l-i-buy-${idx}`,
                                                    __btn_id2: i.buyUrl,
                                                    __btn_type: 'href',
                                                }}
                                            >
                                                {t.buy}
                                            </EcoLink>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
                <ul className={`${prefixCls}-card-type-a__content-right`}>
                    {rItemsSubs.map((i: any, idx: number) => (
                        <li
                            className={`${prefixCls}-card-type-a__content-right-item`}
                            style={{
                                animation: getCardAnimation(idx, lItemsSubs.length),
                            }}
                            key={i.updateTime || idx}
                        >
                            <EcoLink
                                className={`${prefixCls}-card-type-a__content-right-item-link GtmModuleData-btn-href header-nvd-t2-r-${idx}`}
                                href={i.url}
                                target={getTarget(i.url)}
                                onClick={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'top_second_navigation',
                                        navigation_name: `${title}_${i.name}`,

                                        __btn_id1: `header-nvd-t2-r-${idx}`,
                                        __btn_id2: i.url,
                                        __btn_type: 'common',
                                    });
                                }}
                            >
                                <EcoImg className={`${prefixCls}-card-type-a__content-right-item-icon`} pc={i.pictureUrl} />
                                {i.name}
                            </EcoLink>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};
export default TypeContent;
